import { container, title } from "assets/jss/realtimeWidget.js";
import { makeStyles } from "@material-ui/core/styles";

const facilityViewStyle = makeStyles((theme) => ({
  container: {
    zIndex: "12",
    ...container
  },
  title: {
    ...title,
    display: "inline-block",
    position: "relative",
    marginTop: "30px",
    minHeight: "32px",
    color: "#FFFFFF",
    textDecoration: "none"
  },
  subtitle: {
    fontSize: "1.313rem",
    maxWidth: "500px",
    margin: "10px auto 0"
  },
  subheader: {
    color: "#000000",
    paddingLeft: "40px",
    "@media (min-width: 960px)": {
      display: "none",
    },
  },
  responsive: {
    "@media (min-width: 960px)": {
      display: "none",
    },
  },
  responsive2: {
    "@media (max-width: 960px)": {
      display: "none",
    },
  },
  main: {
    margin: "20px 30px 0px",
    background: "#FFFFFF",
    position: "relative",
    zIndex: "3"
  },
  mainRaised: {
    margin: "-60px 30px 0px",
    borderRadius: "6px",
    boxShadow:
      "0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)"
  },
  availableContainer: {
    backgroundColor: "rgba(242, 242, 242, 1)",
    height: "auto",
    "@media (max-width: 960px)": {
      order: 0
    },
    "@media (min-width: 960px)": {
      order: 1
    },
  },
  assetsSectionContainer: {
    "@media (max-width: 960px)": {
      order: 1
    },
    "@media (min-width: 960px)": {
      order: 0
    },
  },
  supportedConsolesSectionContainerWhenSmall: {
    "@media (max-width: 960px)": {
      display: "none"
    },
    "@media (min-width: 960px)": {
      padding: "20px 40px 20px 40px"
    },
  },
  supportedConsolesSectionContainerWhenBig: {
    "@media (min-width: 960px)": {
      display: "none"
    },
    "@media (max-width: 960px)": {
      order: 3,
      backgroundColor: "rgba(242, 242, 242, 1)",
      padding: "20px 40px 20px 40px"
    },
  },
  fillEmptySpace: {
    "@media (max-width: 960px)": {
      display: "none"
    },
    "@media (min-width: 960px)": {
      order: 2,
    },
  },
  floatingIcon: {
    margin: "10px",
    top: 'auto',
    right: 20,
    bottom: 20,
    left: 'auto',
    position: 'fixed',
    backgroundColor: theme.palette.primary.main
  },
  extendedIcon: {
    marginRight: "5px",
  },
  feedbackText: {
    textTransform: "Capitalize",
    fontSize: "1.3em"
  }
}));

export default facilityViewStyle;
